export { default as Panel } from './Panel';
export { default as Heading } from './PanelHeading';
export { default as Tabs } from './PanelTabs';
export { default as Tab } from './PanelTab';
export { default as Block } from './PanelBlock';
export { default as Icon } from './PanelIcon';


// WEBPACK FOOTER //
// ./src/components/Panel/index.ts